(() => {
  const dialog = document.querySelector('.ak-transfer-dialog');
  const opener = document.querySelector('[data-ak-open]');
  if (!dialog || !opener) return;
  opener.addEventListener('click', () => dialog.showModal());
  dialog.querySelector('[data-ak-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener.focus());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } });
})();